<div class="space-y-6">
  <app-page-header
    [backTo]="['/users']"
    backLabel="Retour à la liste"
    title="Nouvel utilisateur"
    subtitle="Crée un compte sur la plateforme. L'utilisateur recevra ses identifiants par email."
  />

  <app-user-form
    mode="create"
    [submitting]="submitting()"
    [serverError]="serverError()"
    (save)="onSave($event)"
    (cancel)="onCancel()"
  />
</div>
